import {
  FETCH_INVENTORY_SUCCEEDED,
  MAP_DESTINATION_TO_PRODUCT_LOCATION,
  BULK_UPDATE_INVENTORIES_LOCATION_SUCCEEDED,
  SELECT_INVENTORY,
  SELECT_ALL_ITEMS,
  UPDATED_DESTINATION_LOCATIONS_REQUESTED,
  PRE_FILL_FILTER_FILTER,
  INVENTORY_UPDATE_PRODUCT_DESTINATION,
  INVENTORY_UPDATE_PRODUCT_LOCATION,
  ADD_PENDING_PRODUCT,
  FETCH_INVENTORY_REQUESTED,
  REMOVE_PENDING_PRODUCT,
  SELECT_DESTINATION_OF_PENDING_PRODUCT,
  SELECT_LOCATION_OF_PENDING_PRODUCT,
  FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED
} from './list.action';
import * as _ from 'lodash';
import { SAVE_PRODUCT_LOCATION_SUCCEEDED } from '../batch/batch.actions';
import { InventoryInterface } from '../../../models/Inventory';

const ProductLocation = (state: InventoryInterface, action) => {
  switch (action.type) {
    case INVENTORY_UPDATE_PRODUCT_DESTINATION:
      if (action.item.getId() === state.getId()) {
        state = _.assign(_.clone(state), {
          destination_id: action.data.getId(),
          destination: action.data
        });
        let location = _.find(action.data.locations, item => item.getId() === (state as any).location_id);
        if (_.isUndefined(location)) {
          delete state['location_id'];
          delete state['location'];
        }
      }
      return state;
    case SAVE_PRODUCT_LOCATION_SUCCEEDED:
      if (action.data.getProductId() === (state as any).getProductId()) {
        state = _.clone(state);
        (state as any).destination_id = action.data.destination_id;
        (state as any).location_id = action.data.location_id;
        state.saveChanged();
      }
      return state;
    case INVENTORY_UPDATE_PRODUCT_LOCATION:
      if (action.item.getId() === state.getId()) {
        state = _.assign(_.clone(state), {
          location_id: action.data.getId(),
          location: action.data
        });
      }
      return state;
    case FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED:
      let last_track = _.find(action.data, item => item.getProductId() === state.getProductId());
      if (!_.isUndefined(last_track)) {
        (state as any).last_track = last_track;
      }
      return state;
    default:
      return state;
  }
};

const PendingProduct = (state = {}, action) => {
  switch (action.type) {
    case SELECT_DESTINATION_OF_PENDING_PRODUCT:
      if (action.item.getId() === (state as any).getId()) {
        state = _.assign(_.clone(state), {
          destination_id: action.data.getId(),
          destination: action.data
        });
        let location = _.find(action.data.locations, item => item.getId() === (state as any).location_id);
        if (_.isUndefined(location)) {
          delete state['location_id'];
          delete state['location'];
        }
      }
      return state;
    case SELECT_LOCATION_OF_PENDING_PRODUCT:
      if (action.item.getId() === (state as any).getId()) {
        state = _.assign(_.clone(state), {
          location_id: action.data.getId(),
          location: action.data
        });
      }
      return state;
    default:
      return state;
  }
};

const Filters = (state = {}, action) => {
  switch (action.type) {
    case PRE_FILL_FILTER_FILTER:
      if (action.data['destination_id']) {
        delete state['destination_id'];
      }
      if (action.data['location_id']) {
        delete state['location_id'];
      }
      if (action.data['process_status']) {
        delete state['process_status'];
      }
      return _.assign(state, action.data);
    case MAP_DESTINATION_TO_PRODUCT_LOCATION:
      if (!_.isUndefined((state as any).destination_id)) {
        (state as any).destination = _.find(action.data, item => (item as any).getId() === (state as any).destination_id);
      } else {
        (state as any).destination = undefined;
      }
      if (!_.isUndefined((state as any).location_id) && !_.isUndefined((state as any).destination) && _.isArray((state as any).destination.locations)) {
        (state as any).location = _.find((state as any).destination.locations, item => (item as any).getId() === (state as any).location_id);
      } else {
        (state as any).location = undefined;
      }
      return state;
    default:
      return state;
  }
};

export const list = (state = { fetched: false, items: [], pending_products: [], updated: false, filters: {}, query: {} }, action) => {
  switch (action.type) {
    case FETCH_INVENTORY_REQUESTED:
      return _.assign({}, state, { query: action.data });
    case FETCH_INVENTORY_SUCCEEDED:
      return _.assign({}, state, {
        fetched: true,
        items: action.data,
        pagination: action.pagination
      });

    case MAP_DESTINATION_TO_PRODUCT_LOCATION:
      return _.assign({}, state, {
        items: _.map(state.items, item => {
          let destination = _.find(action.data, i => i.getId() === item.getDestinationId());
          if (!_.isUndefined(destination) && _.isArray(destination.getLocations())) {
            item.destination = destination;
            item.location = _.find(destination.getLocations(), location => location.getId() === item.getLocationId());
          }
          return item;
        }),
        filters: Filters(state.filters, action)
      });

    case SELECT_INVENTORY:
      return _.assign({}, state, {
        items: _.map(state.items, item => (item.id === action.data.id ? _.assign(item, { selected: action.selected === 'on' }) : item))
      });

    case SELECT_ALL_ITEMS:
      if (action.data) {
        return _.assign({}, state, {
          items: _.map(state.items, item => _.assign(_.clone(item), { selected: true }))
        });
      } else {
        return _.assign({}, state, {
          items: _.map(state.items, item => _.assign(_.clone(item), { selected: false }))
        });
      }
    case PRE_FILL_FILTER_FILTER:
      return _.assign(state, {
        filters: Filters(state.filters, action)
      });
    case SAVE_PRODUCT_LOCATION_SUCCEEDED:
      if (action.com === 'INVENTORY_PRODUCT_PAGE') {
        return _.assign({}, state, { items: _.map(state.items, item => ProductLocation(item, action)) });
      }
      return state;
    case INVENTORY_UPDATE_PRODUCT_DESTINATION:
    case INVENTORY_UPDATE_PRODUCT_LOCATION:
    case FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED:
      return _.assign({}, state, { items: _.map(state.items, item => ProductLocation(item, action)) });
    case SELECT_DESTINATION_OF_PENDING_PRODUCT:
    case SELECT_LOCATION_OF_PENDING_PRODUCT:
      return _.assign({}, state, { pending_products: _.map(state.pending_products, item => PendingProduct(item, action)) });
    case ADD_PENDING_PRODUCT:
      return _.assign({}, state, { pending_products: _.uniqBy([...state.pending_products, ...action.data], 'id') });
    case REMOVE_PENDING_PRODUCT:
      return _.assign({}, state, { pending_products: _.filter(state.pending_products, item => !_.includes(action.data, item.getId())) });
    default:
      return state;
  }
};
